import { FC, useContext, useEffect, useRef, useState } from "react";

import FooterText from "../../components/footerText";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";
import { DocumentAPIError, DocumentAPIResponse } from "./types";
import { ACCEPTED_FILE_EXTENSIONS, ACCEPTED_FILE_PDF_TYPE } from "src/constants";


const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB in bytes

const HubUploadPEF: FC = (): JSX.Element => {
  const [uploadFile, changeUploadFile] = useState<FileList | null>(null);
  const [uploadFileInputError, changeUploadFileInputError] = useState<string | null>(null);
 
  const ref = useRef<HTMLInputElement>(null);
  const { showToast } = useContext(ToastContext);
  const { loading: uplaodPEFLoading, error: uploadPEFFileError, data: uploadPEFFileResponse, mutate: uploadPEFDocument } =
    useFetch<DocumentAPIResponse>(APIEndpoints.UPLOAD_PEF);

  useEffect(() => {
    if (uploadPEFFileError) {
      changeUploadFile(null);
      reset()
      const {error } = uploadPEFFileError as unknown as DocumentAPIError; 
      showToast([error  || `File Not Uploaded. Please try again.`],ToastTypes.ERROR)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadPEFFileError]);

  useEffect(() => {
    if (uploadPEFFileResponse) {
      changeUploadFile(null);
      reset();
      showToast(["IVR Request Form uploaded successfully."], ToastTypes.SUCCESS);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadPEFFileResponse]);

  const uploadForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (uploadFile) {
      const formData = new FormData();
      formData.append('fax_document', uploadFile[0]);
      uploadPEFDocument(formData);
    }
  };

  const onUplaodCalled = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const caseFileExt = `.${files[0].name.split(".").pop()}`;
      console.log("file ext", caseFileExt, files[0].type)
      const isExtAccepted =  ACCEPTED_FILE_PDF_TYPE && ACCEPTED_FILE_PDF_TYPE[caseFileExt] === files[0].type;

      if (!isExtAccepted) {
        reset()
        changeUploadFileInputError(`Not an acceptable format. The accepted format is PDF only`);
      } else if (files[0].size > MAX_FILE_SIZE) {
        reset()
        changeUploadFileInputError("File size exceeds 25MB limit");
      } else {
        changeUploadFileInputError(null);
        changeUploadFile(files)
      }
    }
  }

  const reset = () => {
    if(ref && ref.current){
      ref.current.value = ""
    }
  };

  const clearDataAndForm = () => {
    changeUploadFile(null);
    reset();
  };

  return (
    <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
      <div className="container d-flex flex-fill flex-column align-items-center pt-4 pb-4 ps-4 pe-4">
        <div className="card" style={{ marginTop: 150 }}>
          <div className="card-header">
            <h1 className="text-primary h4 p-2 mb-0">Upload IVR Request Form</h1>
          </div>

          <div className="card-body">
            <form onSubmit={uploadForm}>
              <p className="fs-6">
                Please select and upload a completed IVR Request Form to have our team transcribe it and begin the benefits investigation process.
              </p>

              <div className="input-group mb-3">
                <input type="file" className="form-control" id="fileUpload" onChange={onUplaodCalled} ref={ref} />

                {uploadFile ? (
                  <button className="btn btn-outline-danger" disabled={!uploadFile || uplaodPEFLoading} type="button" id="fileUpload"
                    onClick={clearDataAndForm}
                  >
                    Clear
                  </button>
                ) : null}
                <button className="btn btn-primary" disabled={!uploadFile || uplaodPEFLoading} type="submit" id="fileUpload">
                  {uplaodPEFLoading ? (<i className="spinner-border"></i>) : null} Upload
                </button>
              </div>
            </form>
            {uploadFileInputError && <p className="d-block form-text text-danger mb-0">{uploadFileInputError}</p>}

            {/* <p className="form-text text-black fst-italic mb-0 mt-3">
              * Please ensure that the uploaded file is in <span className="fw-bold">Pdf</span> format and should not exceed <span className="fw-bold">25MB</span> in size.
            </p> */}
            <p className="form-text text-black fst-italic mb-0 mt-3" >
              Please upload the file in PDF (.pdf) format only. The file size must not exceed 25 MB
            </p>

          </div>

        </div>
      </div>

      <FooterText footerType="white" />
    </div>
  );
};

export default HubUploadPEF;
